/* resources/js/woocommerce/archive/index.js
   WooCommerce Archive – bundler voor modules in deze map */

import { mount as mountLoadMore }    from './loadMore.js';
import { mount as mountPriceFilter } from './priceFilter.js';
import { mount as mountAttrFilters } from './attrFilters.js';
import archiveFilters from './archiveFilters.js'; // default export

// -------- Helper: robuuste pagina-detectie --------
function isArchivePage() {
  const b = document.body?.classList || new DOMTokenList();
  const byBody =
    b.contains('post-type-archive-product') ||
    b.contains('tax-product_cat') ||
    b.contains('tax-product_tag') ||
    b.contains('woocommerce-shop') ||
    (b.contains('archive') && b.contains('woocommerce'));

  // Jouw eigen markers/markup
  const byMarkers =
    !!document.querySelector('[data-archive-offcanvas]') ||
    !!document.querySelector('[data-wc-archive]');

  // Generieke Woo archive hints
  const byDom =
    !!document.querySelector('.woocommerce ul.products, .woocommerce .products') ||
    !!document.querySelector('.archive.woocommerce');

  return byBody || byMarkers || byDom;
}

// -------- Public mount (wordt ook ge-exposed voor debug) --------
export function mount() {
  if (!isArchivePage()) return;

  try { archiveFilters?.(); }   catch (e) { console.error('[Archive] archiveFilters failed', e); }
  try { mountLoadMore?.(); }    catch (e) { console.error('[Archive] loadMore failed', e); }
  try { mountPriceFilter?.(); } catch (e) { console.error('[Archive] priceFilter failed', e); }
  try { mountAttrFilters?.(); } catch (e) { console.error('[Archive] attrFilters failed', e); }
}

// -------- Expose voor console-debug --------
window.__wkArchiveMountRef = {
  mount,
  version: '1.0.3', // bump gerust bij wijzigingen
};

// -------- Auto-boot wanneer dit bestand als losse entry is opgenomen --------
function bootOnce() {
  if (window.__wkArchiveBooted) return;
  window.__wkArchiveBooted = true;
  try { mount(); } catch (e) { console.error('[Archive] mount failed', e); }
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootOnce, { once: true });
} else {
  bootOnce();
}
